import { Field, TextInput } from '@carboledger/ui';
import { useTranslations } from '@/hooks';
import { newPasswordValidation } from '../authValidation';

/**
 * Props:
 *   showPassword  reveals the value as plain text
 */
export const NewPasswordField = ({ showPassword = false }) => {
  const t = useTranslations();

  return (
    <Field name="password" required rules={newPasswordValidation.password}>
      {({ id, name, value, onChange, onBlur, status, message, required }) => (
        <TextInput
          id={id}
          name={name}
          label={t('AUTH_NEW_PASSWORD_LABEL')}
          placeholder={t('AUTH_NEW_PASSWORD_PLACEHOLDER')}
          type={showPassword ? 'text' : 'password'}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          status={status}
          message={message}
          required={required}
        />
      )}
    </Field>
  );
};

/**
 * Props:
 *   showPassword  reveals the value as plain text
 */
export const ConfirmPasswordField = ({ showPassword = false }) => {
  const t = useTranslations();

  return (
    <Field name="confirmPassword" required rules={newPasswordValidation.confirmPassword}>
      {({ id, name, value, onChange, onBlur, status, message, required }) => (
        <TextInput
          id={id}
          name={name}
          label={t('AUTH_CONFIRM_PASSWORD_LABEL')}
          placeholder={t('AUTH_CONFIRM_PASSWORD_PLACEHOLDER')}
          type={showPassword ? 'text' : 'password'}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          status={status}
          message={message}
          required={required}
        />
      )}
    </Field>
  );
};
